import {connect} from 'react-redux';
import openModal from 'rlink-router/actions/openModal';
import navTo from 'rlink-router/actions/navTo';

import ShopItem from 'rlink-shop/components/ShopItem';

export default connect(
  null,
  (dispatch, ownProps) => ({
    onOpenInfoModal (buildContext, content) {
      dispatch(openModal({
        content,
        nudgeOffset: 2, //Go back and refactor modal nudges
        bindOnCloseToClassNames: [ownProps.css['info-modal']],
        onClose: () => {
          dispatch(navTo(buildContext, {
            view: 'buy',
            keepScrollPosition: true,
          }));
        },
      }));
    },
  }),
)(ShopItem);



// WEBPACK FOOTER //
// ./lib/rlink-shop/components/connected/ShopItem.jsx